var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    textAlign: _vm.textAlign,
    width: _vm.width + '%',
    margin: _vm.margin
  })},[_c('label',{style:([_vm.labelStyles])},[_vm._v(_vm._s(_vm.labelTitle))]),(_vm.required)?_c('span',{staticClass:"pink--text"},[_vm._v("*")]):_vm._e(),_c('textarea',{style:([_vm.inputStyles]),attrs:{"placeholder":_vm.placeholder,"required":_vm.required,"type":_vm.type,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }